module.exports = __webpack_public_path__ + "img/contract@2x.93890207.png";